import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconInfo } from '@redteclab/icons'

import {
  ProductVolumePricingModal,
  useProductVolumePricingContext,
} from '../../../../../product'
import { ProductSearchFlag } from '../../../ProductSearchFlag'

export const ProductSearchResultItemVolumePricingLabel: FC = () => {
  const { openableControls } = useProductVolumePricingContext()

  return (
    <>
      <ProductSearchFlag
        className="border-light-primary-strong bg-light-tertiary"
        data-qa-id="volume-pricing-modal-button"
        name="productLabelVolumePricing"
        onClick={openableControls.handleOpen}
        slots={{
          root: 'button',
        }}
        type="button"
      >
        <FormattedMessage id="volumePricing.modal.title" />
        <IconInfo className="ml-1 size-4" />
      </ProductSearchFlag>
      <ProductVolumePricingModal />
    </>
  )
}
